export const validateType = {
  STRINGS: 'STRINGS',
  BOOLEAN: 'BOOLEAN',
  INTEGER: 'INTEGER',
  TIME:    'TIME',
  HTML:    'HTML',
  OBJECT:  'OBJECT',
}

export const timeType = {
  NOW: 'NOW',
  ONE_YEAR_LATER: 'ONE_YEAR_LATER',
}

export const getTimeValue = (type) => {
  var dt = new Date()
  switch (type) {
    case timeType.NOW:
      return dt.getTime()
    case timeType.ONE_YEAR_LATER:
      dt.setFullYear(dt.getFullYear() + 1)
      return dt.getTime()
    default:
      return 0
  }
}

export const validate = (param, props) => {
  var value, result
  result = {}
  props.forEach((p) => {
    value = param[p.name]
    
    result[p.name] = {}
    if (p.must === true) {
      result[p.name].must = Boolean(value !== undefined)
    }
    if (value === undefined) {
      return undefined
    }
    
    switch(p.type) {
      case validateType.STRINGS:
      case validateType.HTML:
        result[p.name].type = Boolean(typeof(value) === 'string')
        break
      case validateType.INTEGER:
      case validateType.TIME:
        result[p.name].type = Boolean(typeof(value) === 'number')
        break
      case validateType.BOOLEAN:
        result[p.name].type = Boolean(typeof(value) === 'boolean')
        break
      case validateType.OBJECT:
        result[p.name].type = Boolean(typeof(value) === 'object')
        break
      default:
        return
    }

    if ('maxStringLength' in p) {
      result[p.name].maxStringLength = Boolean(value.length <= p.maxStringLength)
    }

    if ('minStringLength' in p) {
      result[p.name].minStringLength = Boolean(value.length >= p.minStringLength)
    }

    if ('maxValue' in p) {
      result[p.name].maxValue = Boolean(value <= p.maxValue)
    }

    if ('minValue' in p) {
      result[p.name].minValue = Boolean(value >= p.minValue)
    }

    if ('maxTime' in p) {
      result[p.name].maxTime = Boolean(value <= getTimeValue(p.maxTime))
    }

    if ('minTime' in p) {
      result[p.name].minTime = Boolean(value >= getTimeValue(p.minValue))
    }
  })
  return Object.keys(result).every((key) => {
    return Object.keys(result[key]).every((validationName) => result[key][validationName] === true)
  })
}



// WEBPACK FOOTER //
// ./src/lib/validator.js